<template>
  <tc-text-input
    ref="inputWrapper"
    v-bind="$attrs"
    v-on="eventListeners"
    :id="resolvedId"
    :label="label"
    :disabled="disabled"
    :required="isRequired"
    :validation-state="validationState"
    :validation-message="validationMessage"
    :assistive-text="assistiveText"
    :value="value"
  />
</template>

<script>
import TcTextInput from '@telia/tc-text-input'
import { validatable, formField } from '@telia/tc-vue-mixins'
import mountFlatpickr from 'flatpickr'
import locales from 'flatpickr/dist/l10n/sv'

export default {
  name: 'TcDatePicker',
  components: {
    TcTextInput
  },
  mixins: [formField, validatable],
  inheritAttrs: false,
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default: () => ({
        locale: locales.sv
      })
    }
  },
  data() {
    return {
      flatpickrInstance: null,
      flatpickrOptions: { locale: locales.sv, ...this.options }
    }
  },
  computed: {
    eventListeners() {
      let vm = this
      return {
        ...vm.$listeners,
        input(date) {
          vm.$emit('input', date)
        }
      }
    }
  },
  mounted() {
    const inputElements = this.$refs.inputWrapper.$el.getElementsByTagName(
      'input'
    )
    const inputElement = inputElements[0]
    this.flatpickrInstance = mountFlatpickr(inputElement, this.flatpickrOptions)
  },
  destroyed() {
    if (this.flatpickrInstance) {
      this.flatpickrInstance.destroy()
      this.flatpickrInstance = null
    }
  }
}
</script>
<style lang="scss">
@import '~@telia/flatpickr-style/dist/index';
@import '~@telia/tc-vue-mixins/src/form-mixins';

.flatpickr-input[readonly] {
  width: 100%;
  margin: 0;
  border-radius: 2px;
  padding-left: 1.6rem;
  padding-right: 1.6rem;

  &:focus,
  &:hover {
    padding-left: 1.6rem;
    padding-right: 1.6rem;
  }

  &:focus {
    @include focus;
  }
}

.flatpickr-day {
  &:focus,
  &:hover {
    @include tc-bg-color-core-purple(300);
  }
}
</style>
